var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styles from './TreeSelectOptions.module.scss';
import { TreeSelectOption } from './components';
import { v4 as uuid } from 'uuid';
var TreeSelectOptions = function (_a) {
    var options = _a.options, selected = _a.selected, opened = _a.opened, marked = _a.marked, disabled = _a.disabled, className = _a.className, onChange = _a.onChange, onOpenedChange = _a.onOpenedChange;
    var renderOptions = function () {
        return (_jsx(_Fragment, { children: options.map(function (opt) { return (_jsx(TreeSelectOption, { option: opt, selected: selected, opened: opened, marked: marked, disabled: disabled, onChange: onChange, onOpenedChange: onOpenedChange }, uuid())); }) }));
    };
    return _jsx("ul", __assign({ className: "".concat(styles.Options, " ").concat(className ? className : '') }, { children: renderOptions() }));
};
TreeSelectOptions.propTypes = {
    options: PropTypes.arrayOf(PropTypes.any).isRequired,
    selected: PropTypes.arrayOf(PropTypes.any).isRequired,
    opened: PropTypes.arrayOf(PropTypes.any).isRequired,
    marked: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onOpenedChange: PropTypes.func.isRequired,
};
export { TreeSelectOptions };
//# sourceMappingURL=TreeSelectOptions.js.map